module.exports = __webpack_public_path__ + "static/WSC_Group_2015_Business_Checklist-e87050142dfbf8f829d559390274b2fd.pdf";